import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper, TextField, Button, CircularProgress } from '@mui/material';
import axios from 'axios';

const ChatbotTutor = () => {
    const { courseId } = useParams();
    const [course, setCourse] = useState(null);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCourseDetails = async () => {
            try {
                const response = await axios.get(`/api/courses/${courseId}`);
                setCourse(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch course details:", error);
                setLoading(false);
            }
        };

        fetchCourseDetails();
    }, [courseId]);

    const handleSend = async () => {
        if (input.trim()) {
            const userMessage = { sender: 'user', text: input };
            setMessages([...messages, userMessage]);
            setInput('');

            try {
                const response = await axios.post('/api/chatbot/interact', {
                    message: input,
                    course_id: courseId,
                    user_id: sessionStorage.getItem('userId')
                });
                const botMessage = { sender: 'bot', text: response.data.response };
                setMessages(prev => [...prev, botMessage]);
            } catch (error) {
                console.error("Failed to send message to chatbot:", error);
                const errorMessage = { sender: 'bot', text: "Sorry, I'm having trouble connecting. Please try again." };
                setMessages(prev => [...prev, errorMessage]);
            }
        }
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (!course) {
        return <Typography>Course not found.</Typography>;
    }

    return (
        <Box sx={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0054A6 0%, #00386e 55%, #001f3f 100%)',
            pt: 4
        }}>
            <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
            <Typography variant="h4" gutterBottom>{course.title}</Typography>
            <Paper sx={{ height: 500, overflowY: 'auto', p: 2, mb: 2 }}>
                {messages.map((msg, index) => (
                    <Box key={index} sx={{ textAlign: msg.sender === 'user' ? 'right' : 'left', mb: 1 }}>
                        <Typography variant="body1" sx={{ display: 'inline-block', p: 1, borderRadius: 1, bgcolor: msg.sender === 'user' ? 'primary.main' : 'grey.300', color: msg.sender === 'user' ? 'white' : 'black' }}>
                            {msg.text}
                        </Typography>
                    </Box>
                ))}
            </Paper>
            <Box sx={{ display: 'flex' }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Type your message..."
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                />
                <Button variant="contained" onClick={handleSend} sx={{ ml: 1 }}>Send</Button>
            </Box>
            </Box>
        </Box>
    );
};

export default ChatbotTutor;
